import { render, staticRenderFns } from "./stepsTwo.vue?vue&type=template&id=21445e95&scoped=true"
import script from "./stepsTwo.vue?vue&type=script&lang=js"
export * from "./stepsTwo.vue?vue&type=script&lang=js"
import style0 from "./stepsTwo.vue?vue&type=style&index=0&id=21445e95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21445e95",
  null
  
)

export default component.exports